<div class="hmhs-dynamic-form mat-typography mat-body mat-app-background">

  <!-- Form Page Heading -->
  @if (formConfig.pages[currentPage]?.showPageHeader) {
    <h1 class="form-heading">
    {{formConfig.pages[currentPage]?.pageHeader}}</h1>
  }

  <!-- Form Entries Loop -->
  @for (entry of formConfig.pages[currentPage]?.entries; track entry; let i = $index) {
    <div class="form-row"
      [ngClass]="{ 'hide-entry': entry.base?.foreverHidden || !entry.base?.display }">
      @if (pageFormGroups) {
        <ptl-entry-as-json [entryConfig]="entry" [form]="pageFormGroups" [currentPage]="formConfig.pages[currentPage]" [formConfig]="formConfig">
        </ptl-entry-as-json>
      }
      @if (entry?.base?.tooltip && entry?.base?.display) {
        <div class="premium-tooltip" matTooltip="{{entry?.base?.tooltip}}">
          <span class="material-symbols-outlined">info</span>
        </div>
      }
    </div>
  }


  <!-- Form Page Nav BUTTONS -->
  <div class="form-buttons">

    @if (formConfig.form.formNavigation.saveButton.display) {
      <div class="save-later">
        <a href="javascript:void(0)" (click)="saveForLaterButton()">
          <span class="text">{{formConfig.form.formNavigation?.saveButton?.content || "SAVE FOR LATER"}}</span>
          <span class="material-symbols-outlined save-icon">save</span>
        </a>
      </div>
    }

    <div class="navigational-controls">
      @if (formConfig.form.formNavigation.backButton.display && currentPage !== 0) {
        <div class="nav-link">
          <a href="javascript:void(0)" (click)="backButton()">
            <span class="material-symbols-outlined">arrow_back</span>
            <span class="text left-text">BACK</span>
          </a>
        </div>
      }

      @if (formConfig.form.formNavigation.nextButton.display && currentPage !== formConfig.pages.length - 1) {
        <div class="nav-link spacer">
          <a href="javascript:void(0)" (click)="nextButton()"
            [ngClass]="{'disable-link' : formConfig.form.formNavigation.nextButton.disable }">
            <span class="text">NEXT</span>
            <span class="material-symbols-outlined">arrow_forward</span>
          </a>
        </div>
      }

      @if (formConfig.form.formNavigation.submitButton.display && currentPage === formConfig.pages.length - 1) {
        <button mat-raised-button color="primary" class="submit-button"
          (click)="submitButton()">
          Submit
        </button>
      }
      
      <!-- No guarantee that saveAsSubmitButton should exist -->
      @if (formConfig.form.formNavigation.saveAsSubmitButton?.display && currentPage === formConfig.pages.length - 1) {
        <button mat-raised-button color="primary" class="submit-button"
          (click)="saveWithFormValidations()">
          {{formConfig.form.formNavigation?.saveAsSubmitButton?.content || "SAVE FOR LATER"}}
        </button>
      }
    </div>

  </div>

</div>
